<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      &copy; Copyright {{ new Date().getFullYear() }} All Rights Reserved | STL (Stardust
      Telecom Ltd.)
    </span>

    <span class="float-md-right d-none d-md-block"></span>
  </p>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>
